export interface IFetchOptions extends RequestInit {
  timeout?: number;
  headers?: Headers | string[][] | Record<string, string>;
}

const fetchWithTimeout = async (url: string, options: IFetchOptions = {}): Promise<Response> => {
  const { timeout = 15000, ...rest } = options;

  if (rest.signal) {
    throw new Error('Signal not supported in timeoutable fetch');
  }

  if (typeof AbortController === 'undefined') {
    await import('abortcontroller-polyfill');
  }

  const controller = new AbortController();
  const { signal } = controller;

  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('Timeout for Promise'));
      controller.abort();
    }, timeout);

    return fetch(url, {
      signal,
      ...rest,
    })
      .then(resolve, reject)
      .then(() => clearTimeout(timer));
  });
};

export default fetchWithTimeout;
